import { render, staticRenderFns } from "./OtoScheduleTable.vue?vue&type=template&id=123eede0&scoped=true&"
import script from "./OtoScheduleTable.vue?vue&type=script&lang=js&"
export * from "./OtoScheduleTable.vue?vue&type=script&lang=js&"
import style0 from "./OtoScheduleTable.vue?vue&type=style&index=0&id=123eede0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123eede0",
  null
  
)

export default component.exports